import React, { useState, useEffect } from "react";

import { ReactComponent as ExpandIcon } from "src/asset/ic_expand_group.svg";
import { ReactComponent as CollapseIcon } from "src/asset/ic_collapse_group.svg";

import styles from "./styles.module.scss";

const TxGroupExpandRenderer = ({ data, node }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    useEffect(() => {
        if (node) {
            setIsExpanded(node.expanded || false);
        }
    }, [node]);

    const handleExpandClick = (e) => {
        e.stopPropagation();

        if (!isExpanded) {
            node.setExpanded(true);
            setIsExpanded(true);
        } else {
            node.setExpanded(false);
            setIsExpanded(false);
        }
    };

    return (
        <div className={styles.numCellContainer}>
            {data && data.parentId === null ? (
                <button
                    className={styles.expandButton}
                    onClick={handleExpandClick}
                    type="button"
                    title={isExpanded ? "Collapse" : "Expand"}
                >
                    {isExpanded ? (
                        <CollapseIcon className={styles.icon} />
                    ) : (
                        <ExpandIcon className={styles.icon} />
                    )}
                </button>
            ) : (
                <span>{node.childIndex + 1}</span>
            )}
        </div>
    );
};

export default TxGroupExpandRenderer;
